<template>
  <div class="video-or-image">
    <img class="video-or-image__image" :src="src" alt="bg" v-if="src.match(/\.(jpeg|jpg|gif|png|webp|svg)$/) != null"/>
    <video class="video-or-image__video" ref="videoRef" :src="src" muted autoplay loop playsinline preload="auto" v-else/>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  src: string,
}>()

const videoRef = ref<HTMLVideoElement | null>(null);
onMounted(() => {
  videoRef.value?.play();
})
</script>

<style lang="scss">
.video-or-image {
  position: relative;

  &__image, &__video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
}
</style>